module.exports = __webpack_public_path__ + "static/media/add_clients_card_4.63f14e8b.svg";